import React from "react";
import { useMemo } from "react";
import { useForm, Controller } from "react-hook-form";
import { classNames } from "primereact/utils";
import { InputTextarea } from "primereact/inputtextarea";
import { InputNumber } from "primereact/inputnumber";

export const FormNuevoMetodoPago = ({ objeto=null, postMetodoPago }) => {

  const inputRules = {
    nombre: {
      required: {
        value: true,
        message: "Campo requerido",
      },
      maxLength: {
        value: 250,
        message: "Máximo de 250 caracteres",
      },
    },
    interes: {
        required: {
          value: true,
          message: "Campo requerido",
        },
        min: {
          value: -1,
          message: "El valor mínimo es 0",
        },
        max: {
          value: 50,
          message: "El valor máximo es 50",
        },
      },
    contacto: {
        maxLength: {
          value: 200,
          message: "Máximo de 200 caracteres",
        },
      },
  };

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: useMemo(() => {
      return objeto;
    }, [objeto]),
  });

  const onSubmit = (data) => {
    postMetodoPago(data)
  };

  return (
    <form id="FormNuevoMetodoPago" onSubmit={handleSubmit(onSubmit)}>
            <div className="p-fluid formgrid grid pt-2">
                  <div className="field col-12">
                      <label htmlFor="nombre">Nombre del Nuevo Metodo de Pago</label>
                      <Controller
                          name="nombre"
                          control={control}
                          defaultValue=""
                          rules={inputRules.nombre}
                          render={({ field }) => (
                              <InputTextarea {...field} className={classNames({ 'p-invalid': errors?.nombre })} rows={1} cols={30} autoResize />
                          )}
                      />
                      {errors?.nombre && <small className="p-error">{errors.nombre.message}</small>}
                </div>
                <div className="field col-12">
                        <label htmlFor="interes">Interes a Aplicar</label>
                        <Controller
                        name="interes"
                        control={control}
                        rules={inputRules.interes}
                        defaultValue={0}
                        render={({ field }) => (
                            <InputNumber id={field.name} inputRef={field.ref} onBlur={field.onBlur}
                            value={field.value ?? 0}
                            onValueChange={(e) => field.onChange(e)} minFractionDigits={2} mode="decimal"
                            inputClassName={classNames({ 'p-invalid': errors?.interes })}
                            />
                        )} />
                        {errors?.interes && <small className="p-error">{errors.interes.message}</small>}
                    </div>
          </div>
    </form>
  );
};

export default FormNuevoMetodoPago;
